import { useEffect } from "react";
import { useNavigate } from "react-router";

import AppEventTarget, { appEventTypes } from "../events/AppEventTarget";
import { deleteUserToken } from "../helpers/userTokens";
import { rootPaths } from "../../modules/Routing/routesPaths";
import { useQueryClient } from "react-query";
import { setPaymentStatus } from "../helpers/paymentStatus";

const useLogoutRequestHandler = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    const handler = async () => {
      deleteUserToken();
      queryClient.clear();
      navigate(rootPaths.LOGIN, { replace: true });
      setPaymentStatus(null);

      console.info("SUCCESSFULLY LOGGED OUT");
    };

    AppEventTarget.addEventListener(appEventTypes.LOGOUT_REQUEST, handler);
    return () => {
      AppEventTarget.removeEventListener(appEventTypes.LOGOUT_REQUEST, handler);
    };
  }, [navigate, queryClient]);
};

export default useLogoutRequestHandler;
